import React from 'react';
import { Title } from '../../atoms';
import T from 'prop-types';

export const ConfirmationContent = ({ onCancel, onConfirm, title, content, subContent, rightBtnText }) => {
    return <div style={{ background: 'white', padding: 10, borderRadius: 4 }} id="confirmationDiv">
        <div>
            <Title text={title} className="boxTitle" />
            <Title text={content} className="boxContent" />
            <Title text={subContent} className="boxContent" />
        </div>
        <div style={{ display: 'flex', marginTop: 20, justifyContent: 'flex-end' }}>
            <button onClick={onCancel} className="boxCancelBtn">CANCEL</button>
            <button onClick={onConfirm} className="boxDelBtn">{rightBtnText}</button>
        </div>
    </div>;
};

ConfirmationContent.T = {
    text: T.string,
    title: T.string,
    content: T.string,
    subContent: T.string,
    onCancel: T.func,
    onConfirm: T.func
};

ConfirmationContent.defaultProps = {
    rightBtnText: 'DELETE',
};
